export default "__VITE_PUBLIC_ASSET__43ff30be__"